import axios from 'axios'
import request from '@/utils/fetch'
// import BASEURL from '@/utils/ipConfig'

// 登录
export function login ({username, password, loginType}) {
  return axios({
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded'
    },
    baseURL: process.env.API_LOGIN,
    url: '/oauth/token',
    method: 'post',
    data: {
      username: username + ',1',
      password: password,
      grant_type: 'password',
      loginType: loginType,
      client_id: '2019060110331823',
      client_secret: '4HBtqmIpNyF8NEvUoi4uCfCZfhc='
    },
    transformRequest: [function (data) {
      let ret = ''
      for (const it in data) {
        ret += encodeURIComponent(it) + '=' + encodeURIComponent(data[it]) + '&'
      }
      return ret
    }]
  })
}

// 根据token查询菜单信息
// export function systemUserGetMenuByToken (Authorization, token) {
//   return axios({
//     headers: {
//       Authorization
//     },
//     baseURL: process.env.API_PAGE,
//     url: '/homepage/getUserAndMenuByToken',
//     params: {
//       token
//     }
//   })
// }

// 发送手机验证码
export function sendPhoneCode (data) {
  return request({
    url: '/homePage/sendCheckCode',
    method: 'get',
    params: data
  })
}

// 注册
export function userRegister (data) {
  return request({
    url: '/homePage/userRegister',
    method: 'post',
    params: data
  })
}

// 更换手机号
export function updateTelephone (data) {
  return request({
    url: '/homePage/updateTelephone',
    method: 'post',
    params: data
  })
}

// 重置密码
export function resetPassword (data) {
  return request({
    url: '/homePage/resetPassword',
    method: 'post',
    params: data
  })
}



// WEBPACK FOOTER //
// ./src/api/homePage/api_login.js